// =============================================================================
// Finance cockpit — shared constants + pure helpers.
// Ported from the Invoice Program walkthrough (Aug 05 spec).
// =============================================================================
export { money, fmtDate, MATCH_BADGE } from "../invoices/arShared";

// Plan sub-tabs (walkthrough CATS): label → planCategory.
export const CATS = {
  ALL:  { label: "All",  cat: null },
  N30:  { label: "N30",  cat: "CASH" },
  BK:   { label: "BK",   cat: "SPLIT" },
  PoT:  { label: "PoT",  cat: "POT" },
  CTO:  { label: "CTO",  cat: "CTO" },
};

export const STATUS_PILL = {
  Posted: "dark", Sent: "success", AwaitingPost: "info",
  PartiallyApproved: "warning", ReadyForReview: "primary", Generated: "secondary",
  // Closed = generated before the nothing-to-bill guard existed, nothing in it.
  Closed: "light",
};

export const AGING_TONE = {
  Posted: "#0F172A", Overdue: "#DC2626", DueToday: "#B45309", DueSoon: "#2563EB", InProgress: "#94A3B8",
};

// Decision pill — Revised and Sent take precedence over the stored decision.
export function decisionLabel(r) {
  if (r.reviewDecision === "Revised") return { text: "Revised", bg: "warning" };
  if (r.sendStatus === "Sent") return { text: "Sent", bg: "success" };
  switch (r.reviewDecision) {
    case "Approved": return { text: "Approved", bg: "success" };
    case "Rejected": return { text: "Rejected", bg: "danger" };
    case "Adjusted": return { text: "Adjusted", bg: "info" };
    default: return { text: "To review", bg: "secondary" };
  }
}

// Mirrors the server's TermsCodeCodec.ExtractPerInvoiceCap: B{bucket}{NN} —
// bucket '1'-'9' = $1K–$9K, 'A'-'Z' = $10K–$35K (e.g. "B123" → $1,000).
export function capFromTerms(termsCode) {
  const t = (termsCode || "").trim().toUpperCase();
  if (!t.startsWith("B") || t.length < 2) return 0;
  const b = t[1];
  if (b >= "1" && b <= "9") return Number(b) * 1000;
  if (b >= "A" && b <= "Z") return (b.charCodeAt(0) - 64 + 9) * 1000;
  return 0;
}

// Empty-state copy per plan sub-tab (walkthrough emptyForCat).
export function emptyForCat(catKey) {
  if (catKey === "PoT" || catKey === "CTO")
    return `🚧 ${catKey} batches appear here automatically as the ${catKey} plan's daily job runs.`;
  if (catKey === "BK") return "No BK batches yet — they appear here as the daily BK job runs.";
  return "No batches in the last 30 days.";
}
